// extracted by mini-css-extract-plugin
module.exports = {"badge":"PinLevelPermissionBadge_badge__2XHyZ"};